import makeStyles from '@mui/styles/makeStyles';
import {Fonts} from '../../configs/AppEnums';

const useStyles = makeStyles(() => ({
  '@global': {
    // for global styles
    '.MuiLink-root': {
      fontFamily: Fonts.REGULAR,
    },
  },
}));

export default useStyles;
